const PROXIED_COVER_HOSTS = new Set(['audiobookbay.lu', 'audiobb.com', 'www.audiobb.com']);

export function hopeLabCoverUrl(value) {
    if (!value) return '';
    try {
        const base = typeof window !== 'undefined' ? window.location.origin : 'https://hopeteam.xyz';
        const url = new URL(value, base);
        if (url.origin === base && url.pathname === '/api/hopelab/cover') return url.pathname + url.search;
        if (url.protocol === 'https:' && PROXIED_COVER_HOSTS.has(url.hostname.toLowerCase())) {
            url.hash = '';
            return `/api/hopelab/cover?url=${encodeURIComponent(url.toString())}`;
        }
    } catch (_) {}
    return value;
}
